import React from "react";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { ObjectListEditor } from "./widgets.jsx";

// Friendly editor for the `quick_reference` collection.

const ITEM_COLUMNS = [
  { key: "label", label: "Label", span: "md:col-span-4" },
  { key: "value", label: "Value", span: "md:col-span-5" },
  { key: "note", label: "Note", span: "md:col-span-3" },
];

export default function QuickReferenceForm({ value, onChange }) {
  const doc = value || {};
  const set = (k, v) => onChange({ ...doc, [k]: v });
  return (
    <div className="space-y-4" data-testid="quick-reference-form">
      <div className="grid md:grid-cols-2 gap-3">
        <div>
          <Label className="text-xs">Title</Label>
          <Input value={doc.title ?? ""} onChange={(e) => set("title", e.target.value)} className="mt-1 text-sm" data-testid="qrform-title" />
        </div>
        <div>
          <Label className="text-xs">Category</Label>
          <Input value={doc.category ?? ""} onChange={(e) => set("category", e.target.value)} className="mt-1 text-sm" data-testid="qrform-category" />
        </div>
        <div>
          <Label className="text-xs">Icon</Label>
          <Input value={doc.icon ?? ""} onChange={(e) => set("icon", e.target.value)} placeholder="e.g. flash" className="mt-1 text-sm" data-testid="qrform-icon" />
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <Label className="text-xs">Colour</Label>
            <div className="flex items-center gap-2 mt-1">
              <input type="color" value={doc.color || "#111827"} onChange={(e) => set("color", e.target.value)} className="h-9 w-12 rounded border border-slate-200" data-testid="qrform-color" />
              <Input value={doc.color ?? ""} onChange={(e) => set("color", e.target.value)} className="text-sm flex-1" />
            </div>
          </div>
          <div>
            <Label className="text-xs">Order</Label>
            <Input type="number" value={doc.order ?? ""} onChange={(e) => set("order", e.target.value === "" ? undefined : parseInt(e.target.value))} className="mt-1 text-sm" data-testid="qrform-order" />
          </div>
        </div>
      </div>

      <div>
        <Label className="text-xs font-semibold text-[#111827]">Reference items</Label>
        <div className="mt-1">
          <ObjectListEditor value={doc.items} onChange={(v) => set("items", v)} columns={ITEM_COLUMNS} testid="qrform-items" addLabel="Add reference item" />
        </div>
      </div>
      <p className="text-[11px] text-slate-500 px-1">Saving locks this reference from the periodic sync. Other fields are preserved untouched.</p>
    </div>
  );
}
